import React from 'react';
import styled from 'styled-components';
import appConfig from '../../app-config';
const CalorieSpan = styled.span`
  font-size: ${(props) => props.caloriesFontSize || '16px'};
  font-weight: initial;
  letter-spacing: -0.4px;
  color: ${(props) => props.theme[props.caloriesFontColor || 'bodyColor']};
  font-family: ${(props) => props.theme.primaryFontFontFamily};
  align-self: flex-end;
`;

const CalorieString = ({ calories, caloriesFontSize, caloriesFontColor }) => {
  if (!appConfig.isCaloriesEnabled) {
    return null;
  } else {
    const { min_calories, max_calories } = calories;
    if (min_calories === max_calories) {
      return (
        <CalorieSpan
          caloriesFontSize={caloriesFontSize}
          caloriesFontColor={caloriesFontColor}
        >
          {max_calories} Cals
        </CalorieSpan>
      );
    } else if (min_calories > 0 && max_calories > 0) {
      return (
        <CalorieSpan
          caloriesFontSize={caloriesFontSize}
          caloriesFontColor={caloriesFontColor}
        >
          {min_calories}-{max_calories} Cals
        </CalorieSpan>
      );
    } else if (min_calories === 0 && max_calories > 0) {
      return (
        <CalorieSpan
          caloriesFontSize={caloriesFontSize}
          caloriesFontColor={caloriesFontColor}
        >
          {max_calories} Cals
        </CalorieSpan>
      );
    }
  }
};

export default CalorieString;
